import { StreamType as TelemetryStreamType } from '../enums/stream-type';
import { StreamType } from '../../stream/enums/stream-type';
/**
 * Converts streaming protocol StreamType to telemetry StreamType
 */
export const convertToTelemetryStreamType = (streamType) => {
    switch (streamType) {
        case StreamType.DASH:
            return TelemetryStreamType.DASH;
        case StreamType.DASH_WIDEVINE:
            return TelemetryStreamType.DASH_WIDEVINE;
        case StreamType.DASH_PLAYREADY:
            return TelemetryStreamType.DASH_PLAYREADY;
        case StreamType.HLS7:
            return TelemetryStreamType.HLS;
        case StreamType.HLS7_FAIRPLAY:
            return TelemetryStreamType.HLS_FAIRPLAY;
        case StreamType.SMOOTH:
            return TelemetryStreamType.SMOOTH_STREAMING;
        default:
            return TelemetryStreamType.UNKNOWN;
    }
};
